<template>
    <div>
        <el-dialog
                title="Update Service"
                width="700px"
                center
                :close-on-click-modal="false"
                :visible.sync="selfVisible">
            <el-form :model="service" label-position="left" label-width="150px">
                <el-form-item label="Service Name">
                    <el-input placeholder="Service Name" style="width: 80%" v-model="service.serviceName"></el-input>
                </el-form-item>

                <el-form-item label="Upload Icon">
                    <icon-uploader :url.sync="service.icon"></icon-uploader>
                </el-form-item>

                <el-form-item label="Upload Icon">
                    <icon-uploader :set-bg="true" :url.sync="service.icon1"></icon-uploader>
                </el-form-item>

                <el-form-item label="Site Visit">
                    <el-switch v-model="service.siteViste" :active-value="true" :inactive-value="false"
                               active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>

                <el-form-item v-if="service.siteViste" label="Booking Fee">
                    <el-input-number v-model="service.bookingFee"></el-input-number>
                </el-form-item>

                <el-form-item label="Cancel Penalty">
                    <el-input-number v-model="service.cancelPenalty"></el-input-number>
                </el-form-item>

                <el-form-item label="Status">
                    <el-switch v-model="service.status" :active-value="1" :inactive-value="0" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="save">Save</el-button>
                <el-button @click="selfVisible = false">Cancel</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import iconUploader from '../../../components/IconUploader'
    import {updateService, serviceDetail} from '@/api/HomeserviceApi'

    export default {
        name: 'CommServiceModifyDialog',
        props: {id: {required: true, type: Number}, visible: {required: true}},
        components: {iconUploader},
        data() {
            return {
                service: {},
                selfVisible: this.selfVisible ? this.selfVisible : this.visible
            }
        },
        methods: {
            save() {
                updateService(this.service)
                    .then(res => {
                        if (res.status === 200) {
                            this.$msg.success('Success')
                            this.selfVisible = false
                        }
                    })
            },
            loadData() {
                serviceDetail(this.id)
                    .then(res => {
                        this.service = res.data
                    })
            }
        },
        mounted() {
            this.loadData()
        },
        watch: {
            'selfVisible': function (val) {
                this.$emit('update:visible', val)
            }
        }
    }
</script>

<style scoped>

</style>
